'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Tooltip_Tooltip = require('../../display/Tooltip/Tooltip.cjs.js');
const components_forms_TextInput_TextInput = require('../TextInput/TextInput.cjs.js');
const theme_Animation = require('../../../theme/Animation.cjs.js');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
require('react');
const hooks_useCopyToClipboard = require('../../../hooks/useCopyToClipboard.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("CopyTextInput", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: block;
  `,
  copyButton: react.css`
    ${styleMixins_reset.interactiveReset};
    position: relative;
    color: ${theme_Colors.Colors.GrayWarm6};

    &:hover,
    &:focus {
      color: ${theme_Colors.Colors.UiPrimaryStrongest};
    }

    &[disabled] {
      color: ${theme_Colors.Colors.GrayWarm5};
      cursor: not-allowed;
    }
  `,
  tooltip: react.css`
    ${styleMixins_reset.boxSizing};
    opacity: 1;
    transition: opacity ${theme_Animation.Animation.transitionDuration}
      ${theme_Animation.Animation.transitionTimingFunction};
    &[data-hidden='true'] {
      opacity: 0;
    }
  `
});
const CopyTextInput = (_a) => {
  var { size = "medium", type = "text", value } = _a, otherProps = tslib_es6.__rest(_a, ["size", "type", "value"]);
  const props = Object.assign({
    size,
    type,
    value
  }, otherProps);
  const [didCopy, handleCopyText] = hooks_useCopyToClipboard.useCopyToClipboard(value);
  const onClickCopy = (event) => {
    event.preventDefault();
    handleCopyText();
  };
  const renderCopyButton = ({ iconSize }) => {
    const ariaLabel = didCopy ? `"${value}" copied to the clipboard` : `Copy "${value}" to the clipboard`;
    return react.jsx(
      "button",
      { "aria-hidden": !value, "aria-label": ariaLabel, color: "primary", css: Styles.copyButton, disabled: !value, onClick: onClickCopy, type: "button", "data-zds": true },
      react.jsx(components_display_Icon_Icon.Icon, { isBlock: true, name: "actionCopy", size: iconSize }),
      react.jsx(
        "div",
        { css: Styles.tooltip, "data-hidden": !didCopy, "data-zds": true },
        react.jsx(components_display_Tooltip_Tooltip.Tooltip, { "aria-hidden": true, position: "southeast" }, "Copied to clipboard!")
      )
    );
  };
  return react.jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    react.jsx(components_forms_TextInput_TextInput.TextInput, Object.assign({}, props, { "aria-hidden": true, disabledText: value ? "" : "Disabled", isDisabled: !value, isReadonly: Boolean(value), isFocusable: false, renderIconAfter: renderCopyButton }))
  );
};

exports.CopyTextInput = CopyTextInput;
//# sourceMappingURL=CopyTextInput.cjs.js.map
